export default __webpack_public_path__ + "static/lighthouse-logo-2a3669d86aa7ea96b872ee019ffef495.svg";